export const iconSize = { width: '32', height: '32' }

export const STEP = {
  AUTH: 'auth',
  CODE: 'code',
  SUCCESS: 'success',
}

export const MODE = {
  SIGNUP: 'signup',
  LOGIN: 'login',
}

export const OAUTH_PATHS = {
  google: '/users/auth/google_oauth2',
  facebook: '/users/auth/facebook',
}

export const CODE_LENGTH = 6
